import { Box, Checkbox, TextFieldSize } from '@bechtel/gds';
import { ConstructionStatus } from '@bechtel/sr-types';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { DateFieldComponent, FormField, FormSectionHeading, MultiLingualText, TextFieldComponent } from '~/components';
import { usePermissions } from '~/hooks';
import { CheckboxLabelStyled } from '~/views/jobsite-feedback/styled';
import { CableFeedbackFormikState } from '../types';

export const Main: FC<{ loadingCheck: boolean }> = ({ loadingCheck }) => {
  const { setFieldValue, values, setFieldTouched } = useFormikContext<CableFeedbackFormikState>();
  const { canUpdateCableFeedback } = usePermissions();

  return (
    <Box flexDirection={{ sm: 'column' }}>
      <FormSectionHeading heading="Installation" />
      <Box flexDirection={{ sm: 'column' }} mb={{ sm: '700' }}>
        <Box css={{ gap: '72px' }} mb={{ sm: '450' }}>
          <Box css={{ width: '50%' }}>
            <FormField
              alwaysEditable={!loadingCheck && canUpdateCableFeedback}
              memberName="actualLength"
              required={values.constructionStatus !== ConstructionStatus.CABLE_CUT}
            >
              <TextFieldComponent />
            </FormField>
          </Box>
          <Box css={{ width: '50%' }}>
            <FormField alwaysEditable={!loadingCheck && canUpdateCableFeedback} memberName="meggerDevice">
              <TextFieldComponent />
            </FormField>
          </Box>
        </Box>
        <Box css={{ gap: '72px' }}>
          <Box css={{ width: '50%' }}>
            <FormField memberName="installedBy" alwaysEditable={!loadingCheck && canUpdateCableFeedback}>
              <TextFieldComponent />
            </FormField>
          </Box>
          <Box css={{ width: '50%' }}>
            <FormField alwaysEditable={!loadingCheck && canUpdateCableFeedback} memberName="installedTime">
              <DateFieldComponent
                selected={values.installedTime && new Date(values.installedTime)}
                onChange={(date) => {
                  setFieldValue('installedTime', date);
                  setFieldTouched('installedTime', true, false);
                }}
                showPopperArrow={false}
                size={TextFieldSize.SMALL}
                icon="calendar"
                iconStyle="regular"
              />
            </FormField>
          </Box>
        </Box>
      </Box>
      <FormSectionHeading heading="Inspection" />
      <Box css={{ gap: '72px' }} mb={{ sm: '700' }}>
        <Box css={{ width: '50%' }}>
          <FormField alwaysEditable={!loadingCheck && canUpdateCableFeedback} memberName="inspectedBy">
            <TextFieldComponent />
          </FormField>
        </Box>
        <Box css={{ width: '50%' }}>
          <FormField alwaysEditable={!loadingCheck && canUpdateCableFeedback} memberName="inspectedTime">
            <DateFieldComponent
              selected={values.inspectedTime && new Date(values.inspectedTime)}
              onChange={(date) => {
                setFieldValue('inspectedTime', date);
                setFieldTouched('inspectedTime', true, false);
              }}
              showPopperArrow={false}
              size={TextFieldSize.SMALL}
              icon="calendar"
              iconStyle="regular"
            />
          </FormField>
        </Box>
      </Box>
      <Box
        mb={{ sm: '550' }}
        onClick={() => setFieldValue('isRecalcReqd', values.isRecalcReqd ? false : true)}
        css={{ cursor: 'pointer' }}
      >
        <Box alignContent={{ sm: 'center' }}>
          <Checkbox checked={values.isRecalcReqd ? true : false} size={TextFieldSize.MEDIUM} readOnly={true} />
        </Box>
        <CheckboxLabelStyled>
          <MultiLingualText>Recalculate affected raceway fills</MultiLingualText>
        </CheckboxLabelStyled>
      </Box>
    </Box>
  );
};
